<template lang="pug">
  div
    text-about
    what-we-do
    .margin-top
</template>

<script>
  import TextAbout from './TextAbout'
  import WhatWeDo from './WhatWeDo'
  export default {
    components: {
      TextAbout,
      WhatWeDo
    },
    name: 'about',
  }
</script>
